// extracted by mini-css-extract-plugin
export default {"about-page":"About_about-page__XtdiX","section-title":"About_section-title__eq-74","team-grid":"About_team-grid__xdiyM"};